import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { fetchEligibilityBatch } from 'sequences-lib/api/SequencesV2Api';
const useContactEligibilities = (contacts, eligibilityCheckDone, hasSequencesAccess) => {
  const [contactEligibilties, setContactEligibilties] = useState();
  const [hasFetchedEligibilityBatch, setHasFetchedEligibilityBatch] = useState(false);
  if (hasFetchedEligibilityBatch && !eligibilityCheckDone) {
    setHasFetchedEligibilityBatch(false);
  }
  useEffect(() => {
    const vids = contacts.filter(contact => Boolean(contact)).map(contact => contact.get('vid')).toList();
    if (!hasSequencesAccess || eligibilityCheckDone || vids.size === 0) {
      return;
    }
    fetchEligibilityBatch(vids).then(eligibilities => {
      setContactEligibilties(eligibilities);
    }).catch(error => {
      Raven.captureException(error, {
        fingerprint: ['ERROR_API_ELIBILITY_FETCH_FAILED'],
        extra: {
          vids: vids.toJS()
        }
      });
    }).finally(() => {
      return setHasFetchedEligibilityBatch(true);
    });
  }, [contacts, eligibilityCheckDone, hasSequencesAccess, hasFetchedEligibilityBatch]);
  return {
    eligibilities: contactEligibilties,
    shouldUpdateEligibilityCheckDone: hasFetchedEligibilityBatch
  };
};
export default useContactEligibilities;